import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import KashubianFlag from '../assets/icons/flags/kashubian.png';
import SilesianFlag from '../assets/icons/flags/silesian.png';
import cz from './dictionaries/cz.json';
import de from './dictionaries/de.json';
import en from './dictionaries/en.json';
import fr from './dictionaries/fr.json';
import no from './dictionaries/no.json';
import pl from './dictionaries/pl.json';
import ru from './dictionaries/ru.json';
import se from './dictionaries/se.json';
import sk from './dictionaries/sk.json';
import ua from './dictionaries/ua.json';

type FlagReturn = {
  type: 'iso' | 'local';
  value: string;
}

const resources = {
  pl: { translation: pl },
  en: { translation: en },
  de: { translation: de },
  no: { translation: no },
  fr: { translation: fr },
  ru: { translation: ru },
  sk: { translation: sk },
  se: { translation: se },
  ua: { translation: ua },
  cz: { translation: cz },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'pl',
  interpolation: { escapeValue: false },
});

export const countryFlagHelper = (language: string): FlagReturn => {
  switch (language) {
    case 'en':
      return { type: 'iso', value: 'GB' };
    case 'szl':
      return { type: 'local', value: SilesianFlag };
    case 'cbs':
      return { type: 'local', value: KashubianFlag };
    default:
      return { type: 'iso', value: language };
  }
};

export { i18n, resources };
